<template>
    <div>
        <!--<Loading :isShow="isShowLoading"></Loading>-->
        <div v-if="!isShowLoading">
            <div class="apply_box">
                <div class="succ_bg"></div>
                <p class="title">订单提交成功</p>
                <p class="info">{{tips}}</p>
            </div>
            <!--<div class="line"></div>-->
            <!--<div class="agency" v-show="agencyListInfo.length > 0">
              <div class="agency_header">
                <span class="leftIcon"></span><span class="agency_title">贷款机构</span>
              </div>
              <div class="agency_content">
                <van-row gutter="20">
                  <van-col span="12"
                           v-for="(item,index) in agencyListInfo"
                           :key="index">
                    <div class="product">
                      <img :src="item.icon">
                      <div class="center">
                        <p class="name">{{item.name}}</p>
                        <p class="money">{{item.limitStart | filter_loan_money}}-{{item.limitEnd | filter_loan_money}}</p>
                      </div>
                      <div v-if="item.selected" class="icon_act" @click="checkStatus(index)">
                      </div>
                      <div v-else class="icon_no_act" @click="checkStatus(index)">
                      </div>
                    </div>
                  </van-col>
                </van-row>
              </div>
              <div v-show="agencyListInfo.length == 0">
                <img class="products" v-if="status != 0" src="../../assets/img/newpage/2product.png">
              </div>
            </div>-->
            <!--<div>
              <img class="products" v-if="status != 0" src="../../assets/img/newpage/2product.png">
            </div>-->
            <p class="btn"
               @click="toProductDetail">前往申请</p>
        </div>

    </div>

</template>

<script>
    import Loading from '@/components/loading';

    export default {
        components: {
            Loading
        },
        data() {
            return {
                status: 0,//失败成功的标志
                orderId: '',
                tips: '',
                productId: 0,
                webUrl: '',
                agencyListInfo: [],
                isShowLoading: false
            }
        }, created() {
            //this.getAgencyListInfo()
        },
        mounted() {
            this.status = this.$route.query.status;
            this.productId = this.$route.query.productId;
            this.util.title('申请成功');
            if (this.status == 1) {
                this.tips = '根据您的资质，已为您匹配其他通过率高的产品';
                this.getUrl();
            } else if (this.status == 2) {
                this.tips = '为您推荐能提现的新口子，提现最高额度10000元';
                this.getUrl();
            }
            //this.getUrl();
        }, filters: {
            filter_loan_money(value) {
                var num = Number(value);
                if (num < 10000) {
                    return num;
                }
                return (num / 10000).toFixed(0) + "万";
            }
        },
        methods: {
            getUrl() {
                let param = {
                    productId: this.productId,
                };
                this.$get("/app/api/v1/queryByProductId", param)
                    .then((res) => {
                        console.log(res);
                        if (res.code == 200) {
                            this.webUrl = res.data;
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {
                    });
            }, toProductDetail() { //调用android和ios的方法
                if (this.status == 1) {

                    var packageName = localStorage.getItem("packageName");
                    if (packageName && packageName == 'com.tcb.TCHelp') {
                        this.$router.push({
                            path: "/newpage/recommendPage"
                        });
                    } else {
                        this.$get("/app/v1/appHead/product/bySite?site=2")
                            .then((res) => {
                                if (res.code == 200) {
                                    let data = res.data;
                                    if (data) {
                                        var type = data.type;
                                        if (type == 1) {
                                            let json = {
                                                pageUrl: '77xyPrefix/?Page=7&type=1'
                                            }
                                            try {
                                                console.log(json)
                                                window.webkit.messageHandlers.toProductDetail.postMessage(json);//ios
                                            } catch (err) {
                                                console.log(JSON.stringify(json))
                                                window.AppJs.toProductDetail(JSON.stringify(json));//android
                                            }
                                        } else {
                                            this.toRedirect();
                                        }
                                    }
                                }
                            }).catch(err => {
                                this.toRedirect();
                            }
                        )
                    }
                } else if (this.status == 2) {
                    this.toRedirect();
                }
                /*if(this.agencyListInfo && this.agencyListInfo.length>0){
                  this.editAgency();
                }*/
                /*if (this.status == 1) {
                  let param = {
                    event_key: 'h5_success1_apply_view',
                    os: localStorage.getItem("os"),
                    app_market_channel: localStorage.getItem("appMarketChannel"),
                    app_version: localStorage.getItem("appVersion"),
                    customer_id: localStorage.getItem("customerId"),
                    udid: localStorage.getItem("udid"),
                    package_name: localStorage.getItem("packageName"),
                  }
                  this.toCountPoint(param);
                  //window.location.href = this.webUrl;
                  let json = {
                    pageUrl: '77xyPrefix/?Page=7&type=1'
                  }
                  try {
                    console.log(json)
                    window.webkit.messageHandlers.toProductDetail.postMessage(json);//ios
                  } catch (err) {
                    console.log(JSON.stringify(json))
                    window.AppJs.toProductDetail(JSON.stringify(json));//android
                  }
                } else if (this.status == 2) {*/
                /*let param = {
                  event_key: 'h5_success2_apply_view',
                  os: localStorage.getItem("os"),
                  app_market_channel: localStorage.getItem("appMarketChannel"),
                  app_version: localStorage.getItem("appVersion"),
                  customer_id: localStorage.getItem("customerId"),
                  udid: localStorage.getItem("udid"),
                  package_name: localStorage.getItem("packageName"),
                }
                this.toCountPoint(param);
                window.location.href = this.webUrl;*/
                //}
            }, toRedirect() {
                let param = {
                    event_key: 'h5_success2_apply_view',
                    os: localStorage.getItem("os"),
                    app_market_channel: localStorage.getItem("appMarketChannel"),
                    app_version: localStorage.getItem("appVersion"),
                    customer_id: localStorage.getItem("customerId"),
                    udid: localStorage.getItem("udid"),
                    package_name: localStorage.getItem("packageName"),
                }
                this.toCountPoint(param);
                window.location.href = this.webUrl;
            },
            //统计埋点
            toCountPoint(json) {
                this.$get('/app/api/v1/newEventTrace', json)
                    .then(res => {
                        console.log(res)
                        if (res.code == 200) {
                        } else {
                            this.util.toast({msg: res.message})
                        }
                    })
                    .catch(error => {
                    });
            }, getAgencyListInfo() {
                var _this = this;
                this.$get('/app/api/v1/order/zyb/agencyInfos')
                    .then(res => {
                        if (res.code == 200) {
                            _this.agencyListInfo = res.data;
                            _this.isShowLoading = false;
                        }
                    })
                    .catch(error => {
                    });
            }, checkStatus(index) {
                this.agencyListInfo[index].selected = !this.agencyListInfo[index].selected;
            }, editAgency() {
                let agencyIds = "";
                this.agencyListInfo.forEach(e => {
                    if (e.selected) {
                        agencyIds += e.id + ","
                    }
                })
                this.$get('/app/api/v1/order/zyb/editAgency', {agencyIds: agencyIds})
                    .then(res => {
                        if (res.code == 200) {
                            console.log("编辑机构信息成功")
                        }
                    })
                    .catch(error => {
                    });
            },


        }

    }
</script>
<style scoped>
    .apply_box {
        background: #ffffff;
        padding: 0.2rem 0 0.33rem 0;
        text-align: center;
    }

    .bg {
        background: #f7f7f7;
        width: 100%;
        height: 0.1rem;
    }

    /* .header {
      padding: 0.2rem 0 0.33rem 0;
      background: #ffffff;
    } */
    .succ_bg,
    .fail_bg {
        width: 1.09rem;
        height: 0.9rem;
        background: url('../../assets/img/afterLoan/success_bg.png') no-repeat top center;
        background-size: 100% 100%;
        margin: 0 auto;
    }

    .fail_bg {
        background: url('../../assets/img/afterLoan/apply_fail.png') no-repeat top center;
        background-size: 100% 100%;
    }

    .title {
        color: #333;
        font-size: 0.16rem;
        text-align: center;
        margin-bottom: 0.12rem;
    }

    .info {
        font-size: 0.12rem;
        color: #ff514a;
        text-align: center;
    }

    .btn {
        width: 2.45rem;
        background: linear-gradient(
                132deg,
                rgba(89, 163, 252, 1) 0%,
                rgba(60, 100, 246, 1) 100%
        );
        box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
        border-radius: 25px;
        text-align: center;
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        padding: 0.13rem 0;
        margin: 0 auto;
        margin-top: 0.4rem;
    }

    .products {
        width: 100%;
        height: auto;
        background-size: 100% 100%;
    }

    .agency {
        width: 100%;
    }

    .agency .agency_header {
        height: 50px;
        margin: 0 0.25rem;
        line-height: 50px;
        /*border: 1px solid red;*/
    }

    .agency .agency_header .leftIcon {
        display: inline-block;
        width: 3px;
        height: 12px;
        background: #486CFF;
    }

    .agency .agency_header .agency_title {
        margin-left: 0.1rem;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
    }

    .agency_content {
        margin: 0 0.15rem 0 0.13rem;
        border-top: 1px solid #F6F6F6;
        border-bottom: 1px solid #F6F6F6;
        /*border: 1px solid blue;*/
    }

    /*ul{
      display: inline-block;
    }
    ul li{
      width: 50%;
      !*border: 1px solid red;*!
      float: left;
    }*/

    .agency_content img {
        width: 30px;
        height: 30px;
        margin: 0.1rem
    }

    .agency_content .center {
        display: inline-block;
        margin: 0.05rem 0;
    }

    .product {
        display: flex;
        justify-content: space-between;
    }

    .product .center .name {
        font-size: 0.14rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
    }

    .product .center .money {
        font-size: 0.14rem;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #FF514A;
    }

    .icon_act {
        background: url('../../assets/img/afterLoan/choice_check.png') no-repeat top center;
        background-size: 100% 100%;
        width: 0.15rem;
        height: 0.15rem;
        display: inline-block;
        margin: 0.15rem 0 0 0.1rem;
        /*border: 1px solid red;*/
    }

    .icon_no_act {
        background: url('../../assets/img/vip/choice_unCheck.png') no-repeat top center;
        background-size: 100% 100%;
        width: 0.15rem;
        height: 0.15rem;
        display: inline-block;
        margin: 0.15rem 0 0 0.1rem;
    }

    .line {
        width: 375px;
        height: 7px;
        background: #E8E8E8;
        opacity: 0.3;
    }

</style>
